import { STORE_CLEAR } from 'store/constants/storeTypes';

export function storeClear(newState = {}) {
  return { type: STORE_CLEAR, payload: { newState } };
}
